export const datConditons = [
    { license: "B11", totalTG: 12, totalQD: 710, TG_dung_hang: 12, TG_ban_dem_dung_hang: 2, TG_tu_dong: 0 },
    { license: "BTĐ", totalTG: 12, totalQD: 710, TG_dung_hang: 12, TG_ban_dem_dung_hang: 2, TG_tu_dong: 0 },
    { license: "B2", totalTG: 20, totalQD: 810, TG_dung_hang: 17, TG_ban_dem_dung_hang: 2, TG_tu_dong: 3 },
    { license: "BSS", totalTG: 20, totalQD: 810, TG_dung_hang: 17, TG_ban_dem_dung_hang: 2, TG_tu_dong: 3 },
    { license: "C", totalTG: 24, totalQD: 825, TG_dung_hang: 23, TG_ban_dem_dung_hang: 2.5, TG_tu_dong: 1 },
    { license: "C1", totalTG: 24, totalQD: 825, TG_dung_hang: 23, TG_ban_dem_dung_hang: 2.5, TG_tu_dong: 1 },
];
